module.exports = __webpack_public_path__ + "static/img/2012.70c4c3d8.jpg";